module.exports = __webpack_public_path__ + "img/Clothing.25018732.jpg";